import React from 'react';

interface DataTableProps {
  data: any[];
  onShowOrbit: (ntcId: number) => void;
  onShowGrp: (ntcId: number) => void;
  onSelectionChange: (selectedIds: number[]) => void;
}

const DataTable: React.FC<DataTableProps> = ({ data, onShowOrbit, onShowGrp, onSelectionChange }) => {
  const [selected, setSelected] = React.useState<number[]>([]);

  const handleCheckboxChange = (ntcId: number) => {
    const newSelected = selected.includes(ntcId)
      ? selected.filter(id => id !== ntcId)
      : [...selected, ntcId];
    setSelected(newSelected);
    onSelectionChange(newSelected);
  };

  const handleSelectAll = () => {
    if (selected.length === data.length) {
      setSelected([]);
      onSelectionChange([]);
    } else {
      const allIds = data.map(row => row.ntc_id);
      setSelected(allIds);
      onSelectionChange(allIds);
    }
  };
  
  if (!Array.isArray(data) || data.length === 0) {
    return <p>没有数据可显示。请选择一个数据库。</p>;
  }

  const headers = Object.keys(data[0] || {});

  return (
    <div style={{ overflowX: 'auto' }}>
      <table border={1} style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selected.length === data.length && data.length > 0}
                onChange={handleSelectAll}
              />
              操作
            </th>
            {headers.map(header => <th key={header}>{header}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map(row => (
            <tr key={row.ntc_id}>
              <td>
                <input 
                  type="checkbox" 
                  checked={selected.includes(row.ntc_id)} 
                  onChange={() => handleCheckboxChange(row.ntc_id)}
                />
                <button onClick={() => onShowOrbit(row.ntc_id)}>轨道</button>
                <button onClick={() => onShowGrp(row.ntc_id)}>频率组</button>
              </td>
              {headers.map(header => <td key={header}>{row[header]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
